"use client";

import Image from "next/image";

import Heading from "@/components/heading/heading";

import Picture1 from "@/public/png/itinerary/srilanka/royal-kandyan.jpg";
import Picture2 from "@/public/png/itinerary/srilanka/hotel-ashford.jpg";
import Picture3 from "@/public/png/itinerary/srilanka/hibiscus-each-esort.jpg";
import Picture4 from "@/public/png/itinerary/srilanka/best-western-elyon.jpg";


import Wifi from "@/public/svg/itinerary/wifi.svg";
import Pool from "@/public/svg/itinerary/pool.svg";
import AC from "@/public/svg/itinerary/ac.svg";
import Fitness from "@/public/svg/itinerary/fitness.svg";
import Meal from "@/public/svg/itinerary/coffee.svg";
import Spa from "@/public/svg/itinerary/spa.svg";


import arrowLeftNormal from "@/public/svg/itinerary/arrow-left-normal.svg";
import arrowRightNormal from "@/public/svg/itinerary/arrow-right-normal.svg";
import arrowLeftHover from "@/public/svg/itinerary/arrow-left-hover.svg";
import arrowRightHover from "@/public/svg/itinerary/arrow-right-hover.svg";

import Tag from "@/components/tag/Tag";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "@/styles/common/indicator.scss";
import "./hotels.scss";
// Import Swiper styles
import "swiper/css";
import { useState } from "react";

// const Overview = [
//     {
//         name: "Wifi",
//         icon: Wifi,
//     },
//     {
//         name: "Air Conditioning",
//         icon: AC,
//     },
//     {
//         name: "Tea & Coffee Makers",
//         icon: Meal,
//     },
// ];
// const Tags = [
//     {
//         name: "Superior Room",
//     },
//     {
//         name: "Y5 Deluxe Room ",
//     },
// ];

const mappedSlidesData = [
    {
        heading: "Royal Kandyan",
        type: "",
        stars: 4,
        overviewText:
            "A modern retreat set amidst Kandy’s scenic hills, offering comfortable accommodations and warm hospitality. Its prime location provides easy access to cultural highlights, making it an ideal base for exploration.",
        picture: Picture1,
        
        
        
        
        
        overview : [
            {
                name: "Wifi",
                icon: Wifi,
            },
            {
                name: "Air Conditioning",
                icon: AC,
            },
            {
                name: "Tea & Coffee Makers",
                icon: Meal,
            },
        ]

    },
    {
        heading: "Hotel Ashford",
        type: "",
        stars: 3,
        overviewText:
            "A serene retreat in Nuwara Eliya’s cool mountain climate, offering cozy accommodations and friendly service. Its convenient location provides easy access to tea plantations and breathtaking natural attractions",
        picture: Picture2,
       
       
       
       
       
    },
    {
        heading: "Hibiscus Beach Resort",
        type: "",
        stars: 3,
        overviewText:
            "A beachfront haven in Bentota, offering comfortable rooms and a relaxed ambiance. Guests can enjoy scenic ocean views, water sports, and convenient access to local attractions.",
        picture: Picture3,
       
       
       
       
       
    },
    {
        heading: "Best Western Elyon",
        type: "",
        stars: 4,
        overviewText:
            "A contemporary city hotel in Colombo, featuring modern comforts and friendly service. Its prime location offers easy access to business centers, shopping, and cultural attractions.",
        picture: Picture4,
        
        
        
        
        
    },
];

const Hotels = () => {
    const [currentSlideData, setCurrentSlideData] = useState(
        mappedSlidesData[0]
    );
    const [imageSrcL, setImageSrcL] = useState(arrowLeftNormal);
    const [imageSrcR, setImageSrcR] = useState(arrowRightNormal);

    return (
        <div className="hotels-block flex flex-col gap-6 py-9 relative z-[0]">
            <span id="hotels" className="anchor"></span>
            <Heading as="h2">Accommodation</Heading>

            <div className="hotels-slider flex items-center gap-6">
                <div className="picture-wrapper flex flex-col gap-4">
                    <div className="picture">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            slidesPerView={1}
                            spaceBetween={30}
                            centeredSlides={true}
                            onSlideChange={(e) => {
                                setCurrentSlideData(
                                    mappedSlidesData[e.activeIndex]
                                );
                            }}
                            className=""
                            pagination={{
                                el: "#hotel-pagination",
                                clickable: true,
                                bulletClass: "indicator-item",
                                bulletElement: "li",
                                bulletActiveClass: "active",
                            }}
                            wrapperClass=""
                            navigation={{
                                nextEl: ".right",
                                prevEl: ".left",
                            }}
                        >
                            {mappedSlidesData.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <Image
                                            key={index}
                                            loading="lazy"
                                            src={item.picture}
                                            alt="Picture1"
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <div className="left arrow-nagivation flex-center">
                            <Image
                                loading="lazy"
                                src={imageSrcL}
                                onMouseEnter={() =>
                                    setImageSrcL(arrowLeftHover)
                                }
                                onMouseLeave={() =>
                                    setImageSrcL(arrowLeftNormal)
                                }
                                alt="arrow left"
                                className="arrow-icon-left-hotel"
                                width={40}
                                height={40}
                            />
                        </div>
                        <div className="right arrow-nagivation flex-center">
                            <Image
                                loading="lazy"
                                src={imageSrcR}
                                onMouseEnter={() =>
                                    setImageSrcR(arrowRightHover)
                                }
                                onMouseLeave={() =>
                                    setImageSrcR(arrowRightNormal)
                                }
                                alt="arrow right"
                                className="arrow-icon-right-hotel"
                                width={40}
                                height={40}
                            />
                        </div>
                    </div>

                    <ul
                        className="indicator flex-center gap-1 "
                        id="hotel-pagination"
                    >
                        <li className="indicator-item active" />
                        <li className="indicator-item" />
                        <li className="indicator-item" />
                    </ul>
                </div>
                <div className="slider-details flex flex-col gap-2">
                    <Heading as="h4">{currentSlideData.heading}</Heading>
                    <span className="lead">{currentSlideData.type}</span>
                    <ul className="rating-list flex flex-wrap items-center gap-1">
                        {Array(5)
                            .fill("Hi")
                            .map((i, index) => {
                                return index < currentSlideData.stars ? (
                                    <li
                                        className="rating-list-item"
                                        key={index}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52001 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52001 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                                className="filled star"
                                            />
                                        </svg>
                                    </li>
                                ) : (
                                    <li
                                        className="rating-list-item"
                                        key={index}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52002 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52002 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z"
                                                className="unfilled star"
                                            />
                                        </svg>
                                    </li>
                                );
                            })}
                    </ul>
                    
                    
                    
                    
                    
                </div>
            </div>
            <div className="overview flex flex-col gap-3">
                <Heading as="h4">Property Brief</Heading>
                <p className="font-light">{currentSlideData.overviewText}</p>
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
            </div>
        </div>
    );
};

export default Hotels;
